import app from 'flarum/common/app';
import { BooleanGambit } from 'flarum/common/query/IGambit';
export default class SubscriptionGambit extends BooleanGambit {
  key() {
    return [app.translator.trans('flarum-subscriptions.lib.gambits.discussions.subscription.following_key', {}, true), app.translator.trans('flarum-subscriptions.lib.gambits.discussions.subscription.ignoring_key', {}, true)];
  }
  toFilter(matches, negate) {
    const key = (negate ? '-' : '') + this.filterKey();
    return {
      [key]: matches[1]
    };
  }
  filterKey() {
    return 'subscription';
  }
  fromFilter(value, negate) {
    return "".concat(negate ? '-' : '', "is:").concat(value);
  }
  enabled() {
    return !!app.session.user;
  }
}
flarum.reg.add('flarum-subscriptions', 'common/query/discussions/SubscriptionGambit', SubscriptionGambit);